import { useEffect } from 'react'
import { useAppDispatch } from '../states/app/hooks'
import { setAsideName } from '../states/features/Aside/AsideSlice'

const useSetAsideMenu = (name: string) => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(setAsideName(name))
    }, [dispatch, name])
}
export default useSetAsideMenu
